import { Link } from "react-router-dom";
import { Scale, ClipboardList, HardHat, Wrench, Umbrella, Building2, ArrowUpRight } from "lucide-react";
import { SectionHead } from "@/components/site/SectionHead";

const PARTNERS = [
  { icon: Scale, label: "Attorneys & Law Firms" },
  { icon: ClipboardList, label: "Public Adjusters" },
  { icon: HardHat, label: "Engineers & Experts" },
  { icon: Wrench, label: "Contractors & Restoration" },
  { icon: Umbrella, label: "Insurance Professionals" },
  { icon: Building2, label: "Property Managers" },
];

export const PartnerNetwork = ({ showCta = true }) => (
  <section id="partner-network" className="relative py-20 sm:py-24 border-y border-white/5 btr-bg-graphite overflow-hidden" data-testid="partner-network-section">
    <div className="absolute inset-0 btr-grid opacity-20 pointer-events-none" />
    <div className="relative max-w-7xl mx-auto px-6 grid lg:grid-cols-[1fr_1.3fr] gap-10 items-center">
      <div>
        <SectionHead
          badge="Partner Network"
          title={<>One process. A <span className="text-[#a2020b]">trusted network</span>.</>}
          lede="Every engagement is supported by vetted professionals who work from the same documented record."
        />
        {showCta && (
          <Link to="/partners" className="btr-reveal btr-btn-ghost mt-8" data-testid="partner-network-apply-link">
            Apply to Join Our Network <ArrowUpRight className="w-4 h-4" />
          </Link>
        )}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {PARTNERS.map((p, i) => {
          const Icon = p.icon;
          return (
            <div key={p.label} className="btr-reveal btr-glass rounded-lg p-5 flex flex-col gap-3 hover:border-[#a2020b]/45 transition-colors" style={{ transitionDelay: `${i * 40}ms` }} data-testid={`partner-type-${i}`}>
              <Icon className="w-5 h-5 text-[#a2020b]" strokeWidth={1.5} />
              <span className="font-display font-semibold text-white text-sm leading-snug">{p.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);
